<template>
  <div id="help">
    <div class="box">
      <div class="lv3Text t">业立生物科技（上海）股份有限公司</div>
      <el-amap vid="amapDemo" :center="position" ref="" :zoom="zoom">
        <el-amap-marker :position="position"></el-amap-marker>
      </el-amap>
      <div class="text">
        <el-row>
          <el-col :span="12">
            <div class="lv1Text">
              <div class="lv2Text t2">联系方式</div>
              <div>
                <span>E-mail：{{data.hr_email}}</span>
              </div>
              <div>
                <span>全国服务热线：{{data.service_mobile}}</span>
              </div>
              <div>
                <span>QQ：{{data.comp_QQ}}</span>
              </div>
              <div>
                <span>电话：{{data.comp_mobile}}</span>
              </div>
              <div>
                <span>地址：{{data.address}}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="lv1Text">
              <div class="lv2Text t2">宝枫林官方微信</div>
              <div>扫描二维码，即刻与宝枫林亲密互动，还有更多优惠等你来享！</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="lv1Text">
              <img :src="serve + src" style="width:80%;float:right">
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,
      data: "",
      position: [121.449313,31.19833],
      // 121.449313,31.19833
      zoom: 14,
      src: ""
    };
  },
  created() {
    // this.$store.state.user_location = "帮助中心";
    // this.$store.state.leftMenuIndex = 11;
    this.initData();
  },
  methods: {
    //
    initData() {
      this.axios.get(this.serve + "/help/link_us").then(res => {
        this.data = res.data.data;
      });
      this.axios.get(this.serve + "/guanwei_img").then(res => {
        this.src = res.data.data;
      });
    }
  }
};
</script>
<style lang="scss">
#help {
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
    // padding: 30px;
    .t {
      margin-bottom: 40px;
      background: rgba(238, 238, 238, 1);
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      padding-left: 40px;
      text-align: center;
      font-size: 20px;
    }
    .text {
      line-height: 2em;
      padding: 0 20px;
      margin: 40px 0;
      img {
        max-width: 900px;
      }
    }
  }
  .map {
    width: 100%;
    height: 300px;
  }
  #amapDemo {
    height: 300px;
    width: 100%;
  }
  .text {
    line-height: 2em;
  }
  .t2 {
    font-size: 18px;
    margin-bottom: 10px;
  }
}
</style>